import React, { Component } from "react";
import _, { truncate } from 'lodash';

import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

import { getMessage } from "CONFIG/i18n";
import { Row, Col, Input, Label, Button, Modal, ModalBody, ModalHeader, ModalFooter, FormGroup } from "reactstrap";

import { getBootstrapTableOptions, getPhoneNumberWithoutCountryCode, getUserNameForSelectedLanguage } from "UTILS/Utility";

import { modulesAvailableConstant, modulesForSessionContext, subLoggingLevels, CANVAS_TYPES, ERROR } from "UTILS/Constants";
import { formatDateByLocale , getTimeInLocaleTimezone } from "UTILS/DateUtils";
import "../AdminDashboard.less";
import "./SessionList.less";
import "./../../Organisations/Organisations.less";
import "../../Organisations/AddOrganization.less";
import "../../../Spinner/Spinner.less";

import ic_audio from "ASSETS/Images/header_center/ic_audio_deactivate.svg";
import ic_canvas from "ASSETS/Images/header_center/ic_canvas_deactivate.svg";
import ic_message from "ASSETS/Images/header_center/ic_message_deactivate.svg";
import ic_video from "ASSETS/Images/header_center/ic_video_deactivate.svg";
import ic_share from "ASSETS/Images/header_center/ic_share_deactivate.svg";
import ic_location from "ASSETS/Images/header_center/ic_location_deactivate.svg";
import ic_camera from "ASSETS/Images/header_center/ic_snapshot_deactivate.svg";
import ic_pdf from "ASSETS/Images/pdf/ic_pdf.svg";
import ic_admin_co_browse from "ASSETS/Images/header_center/ic_co_browse_deactivate.svg";
import ic_QR_code from "ASSETS/Images/ic_QR_code.svg";
import download_img from "ASSETS/Images/ic_download_allow.svg";
import ic_checked_checkbox from "ASSETS/Images/check_box.svg";
import ic_unchecked_checkbox from "ASSETS/Images/uncheck_box.svg";
import { userAction } from "CONFIG/ActionFactory";
import  toastr  from 'COMPONENTS/ShowTostr/ShowTostr';
import Spinner from "COMPONENTS/Spinner/Spinner";
import PdfViewer from "./PdfViewer"
import ic_app_emulation from "ASSETS/Images/ic_app_emulation_small.svg";
export default class SessionDetails extends Component {
  constructor(props) {
    super(props)
    this.state = {
      show: true,
      currentSubloggingLevel: null,
      showPermissionModal: false,
      inputRecordingPassword: "",
      selectedRecordingLinkId: null,
      downloadingRecordingId: [],
    }

  }

  componentWillUnmount() {
    this.props.onBackClick();
  }

  displayDownloadIcon = (cell, row) => {
    return (<a>
      <img
        className="downloadIcon"
        src={download_img}
        id="downloadIcon"
        onClick={() => { this.downloadObjectURL(row.id, row.storageLink) }}
      />
    </a>)
  }
  displayRecordingDownloadIcon = (cell, row) => {
    return (
      <>
        {!row.isEncoded || this.state.downloadingRecordingId.includes(row.id) ?
          <div 
            className="roundLoader downloadIcon cursorDefault"
            title={getMessage("FILE_GENERATING")}
          >
          </div>:
          <a>
            <img
              className="downloadIcon"
              src={download_img}
              id="downloadIcon"
              onClick={() => {
                this.showPermissionModal(row.id)
              }}
            />
          </a>
        }
      </>
    )
  }

  enterPressedPassword = event => {
    var code = event.keyCode || event.which;
    if (code === 13) {
      this.downloadRecordingObject();
    }
  };

  PermissionModal = () =>{
    return (
      <Modal
        isOpen={this.state.showPermissionModal}
        className="addOrganisationModal"
        centered
      >
        <ModalHeader className="popupHeader p-2">
          {getMessage("ENTER_RECORDING_PASSWORD")}
        </ModalHeader>
        <ModalBody>
          <FormGroup className="d-flex">
            <Label className="label modal-label">
              {getMessage("PASSWORD")}
            </Label>
            <Input
              className="inputFormControl"
              name="inputRecordingPassword"
              type="password"
              onChange={this.handleInputChange}
              onKeyPress={this.enterPressedPassword}
            />
          </FormGroup>
          {this.state.recordingPasswordError &&
          <div className="modal-errors">
            {this.state.recordingPasswordError}
          </div>}
        </ModalBody>
        <ModalFooter className="permissionButtons">
          <Button
            className="buttons borderBtn bgwhite"
            onClick={this.hidePermissionModal}
          >
            {getMessage("CANCEL")}
          </Button>
          <Button
            className="buttons customBtn whiteOnClick"
            onClick={this.downloadRecordingObject}
          > 
            {getMessage("DECISION")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }

  handleInputChange = event => {
    this.setState({
      [event.target.name]: event.target.value.trim(),
    });
  };
  showPermissionModal = (id) => {
    this.setState({
      showPermissionModal: true,
      selectedRecordingLinkId : id
    }) 
  }
  hidePermissionModal = () => {
    this.setState({
      showPermissionModal: false,
      inputRecordingPassword: "",
      selectedRecordingLinkId: null,
      recordingPasswordError: ""
    })
  }

  downloadRecordingObject = () => {
    let selectedRecordingStorageLink
    this.props.recordingObjects.forEach((item) => {
      if (this.state.selectedRecordingLinkId === item.id) {
        selectedRecordingStorageLink = item.storageLink
      }
      return item;
    })
    this.setDownloadingRecordingId(this.state.selectedRecordingLinkId, true)
    this.downloadRecordingObjectURL(this.state.selectedRecordingLinkId, selectedRecordingStorageLink)
  }
  //to get download URL
  downloadRecordingObjectURL = (objectId, storageLink) => {
    userAction.getDownloadRecordingObjectUrl(objectId, this.state.inputRecordingPassword).then(response => {
      this.hidePermissionModal();
      this.downloadRecordingURL(response.data.data.presignedUrl, objectId, storageLink);
    },
    error => {
      console.log('error: ***', error);
      if (error.code === ERROR.WRONG_FILE_PASSWORD ) {
        this.setState({recordingPasswordError: getMessage(error.code)});
      } else {
        navigator.onLine ? 
          toastr.error(getMessage("ERROR_IN_DOWNLOAD")) :
          toastr.error(getMessage("NETWORK_ERROR"))
      }
      this.setDownloadingRecordingId(objectId, false);
    })
  }
  //to download Recording Object on URL
  downloadRecordingURL = (url, id, storageLink) => {
    fetch(url).then(resp => resp.blob())
    .then(blob => {
      var isIE = /*@cc_on!@*/ false || !!document.documentMode;
      let downloadFileName = this.getNameOfObject(storageLink).replace(".zip", "");
      if (isIE) {
        // IE10+
        navigator.msSaveBlob(blob, downloadFileName);
      } else {
        var link = document.createElement("a");
        document.body.appendChild(link);
        link.style = "display: none";
        link.href = window.URL.createObjectURL(blob);
        link.download = downloadFileName;
        link.click();
      }
      this.setDownloadingRecordingId(id, false);
      //  call file delete api
      fetch(url, { method: 'DELETE' });
    },
    error => {
      console.error("Error downloading url" + url, error);
      this.setDownloadingRecordingId(id, false);
    });
  };
  setDownloadingRecordingId = (id, isDownloading) => {
    if (isDownloading) {
      this.setState((state, props) => {
        return{
          downloadingRecordingId: [...state.downloadingRecordingId, id]
        }
      })
    } else {
      this.setState((state, props) => {
        return{
          downloadingRecordingId: state.downloadingRecordingId.filter(itm => itm !== id)
        }
      })
    }
  }
  renderExportCheckboxes = () => {
    return (<label>
      <Input
        type="checkbox"
        className="downloadCheckbox">
      </Input>
    </label>)
  }

  getNameOfObject = (storageLink) => {
    return storageLink.substring(storageLink.lastIndexOf('/') + 1)
  }
  getNameOfRecordingObject = (storageLink) => {
    return storageLink.substring(storageLink.lastIndexOf('/') + 1).replace(/\.zip$/, '')
  }

  showPreviewModal = (row) => {
    let previewObj = row;
    if (previewObj.subLoggingLevel !== CANVAS_TYPES.PDF) {
      this.setState({ spinnerVisible: true })
    }
    userAction.getPresignedObjectUrl(row.id).then(response => {
      let fileUrl = {}
      this.setState({
        previewLink: response.data.data.presignedUrl,
        previewType: previewObj.subLoggingLevel, 
        previewName: this.getNameOfObject(previewObj.storageLink)
      },
      () => {
        fileUrl = response.data.data.presignedUrl;
        this.setState({ showPreview: true, fileUrl: fileUrl })
      })
    },
    error => {
      console.log('error: ***', error);
      this.setState({ showPreview: false, previewLink: "", previewType: '', previewName: '', spinnerVisible: false })
      toastr.error(getMessage("ERROR_IN_PREVIEW"));
    })
   
  }
  displayLink = (cell, row) => {
    return (
      <label>
        <Button color="link" className="nameEllipsis pl-0 noMargin" onClick={() => this.showPreviewModal(row)}>
          {this.getNameOfObject(row.storageLink)}
        </Button>
      </label>
    )
  }

  displayRecordingLink = (cell, row) => {
    return (
      <>
      {!row.isEncoded || this.state.downloadingRecordingId.includes(row.id) ?
        <label className="nameEllipsis pl-0 noMargin">
          {this.getNameOfRecordingObject(row.storageLink)}
        </label> :
        <label>
          <Button 
            color="link"
            className="nameEllipsis pl-0 noMargin"
            onClick={() => this.showPermissionModal(row.id)}
          >
            {this.getNameOfRecordingObject(row.storageLink)}
          </Button>
        </label>
      }
      </>
    )
  }
  // Convert from byte to MB and round up after the decimal point.
  displayFileSize = (cell, row) => {
    let fileSize = this.props.recordingObjects.find((item) => item.id === row.id).fileSize;
    return (
      <label>
        { row.isEncoded ? Math.ceil(fileSize/2**20) + " MB" : "" }
      </label>
    )
  }
  //to get presigned URL
  downloadObjectURL = (objectId, storageLink) => {
    this.props.showSpinner();
    userAction.getPresignedObjectUrl(objectId).then(response => {
      this.downloadURL(response.data.data.presignedUrl, storageLink);
    },
    error => {
      this.props.hideSpinner();
      console.log('error: ***', error);
      navigator.onLine ? 
        toastr.error(getMessage("ERROR_IN_DOWNLOAD")) :
        toastr.error(getMessage("NETWORK_ERROR"))
    })
  }

  //to download Object on URL
  downloadURL = (url, storageLink) => {
    fetch(url).then(resp => resp.blob())
    .then(blob => {
      var isIE = /*@cc_on!@*/ false || !!document.documentMode;
      let downloadFileName = this.getNameOfObject(storageLink);
      if (isIE) {
        // IE10+
        navigator.msSaveBlob(blob, downloadFileName);
      } else {
        var link = document.createElement("a");
        document.body.appendChild(link);
        link.style = "display: none";
        link.href = window.URL.createObjectURL(blob);
        link.download = downloadFileName;
        link.click();
      }
      this.props.hideSpinner();
    },
    error => {
      console.error("Error downloading url" + url, error);
      this.props.hideSpinner();
    });
  };

  displayAllModuleList = () => {
    let allModuleList = [];

    _.map(modulesForSessionContext, (key, value) => {

      switch (key) {
        case "CANVAS":
          allModuleList.push(
            <Col className="paddingR0L3 pointerEventsNone" key={key} xs={12} lg={3}>
              <Label className="label noPadding">
                <img
                  src={ic_checked_checkbox}
                  className="customCheckbox"
                />
                <img
                  src={ic_canvas}
                  style={{
                    height: "20px",
                    width: "20px"
                  }}
                />{" "}
                {getMessage(value)}
              </Label>
            </Col>
          );
          break;
        case "AUDIO":
          allModuleList.push(
            <Col className="paddingR0L3 pointerEventsNone" key={key} xs={12} lg={3}>
              <Label className="label noPadding">
                <img
                  src={this.props.sessionDetails.modules.includes(
                    modulesAvailableConstant.AUDIO) ? ic_checked_checkbox : ic_unchecked_checkbox}
                  className="customCheckbox"
                />
                <img
                  src={ic_audio}
                  style={{
                    height: "20px",
                    width: "20px"
                  }}
                />{" "}
                {getMessage(value)}
              </Label>
            </Col>
          );
          break;
        case "AUDIO_VIDEO":
          allModuleList.push(
            <Col className="paddingR0L3 pointerEventsNone" key={key} xs={12} lg={3}>
              <Label className="label noPadding">
                <img
                  src={this.props.sessionDetails.modules.includes(
                    modulesAvailableConstant.AUDIO_VIDEO) ? ic_checked_checkbox : ic_unchecked_checkbox}
                  className="customCheckbox"
                />
                <img
                  src={ic_video}
                  style={{
                    height: "20px",
                    width: "20px"
                  }}
                />{" "}
                {getMessage(value)}
              </Label>
            </Col>
          );
          break;
        case "SCREENSHARE":
          allModuleList.push(
            <Col className="paddingR0L3 pointerEventsNone" key={key} xs={12} lg={3}>
              <Label className="label noPadding">
                <img
                  src={this.props.sessionDetails.modules.includes(
                    modulesAvailableConstant.SCREENSHARE) ? ic_checked_checkbox : ic_unchecked_checkbox}
                  className="customCheckbox"
                />
                <img
                  src={ic_share}
                  style={{
                    height: "20px",
                    width: "20px"
                  }}
                />{" "}
                {getMessage(value)}
              </Label>
            </Col>
          );
          break;
        case "MSG":
          allModuleList.push(
            <Col className="paddingR0L3 pointerEventsNone" key={key} xs={12} lg={3}>
              <Label className="label noPadding">
                <img
                  src={this.props.sessionDetails.modules.includes(
                    modulesAvailableConstant.CHAT) ? ic_checked_checkbox : ic_unchecked_checkbox}
                  className="customCheckbox"
                />
                <img
                  src={ic_message}
                  style={{
                    height: "20px",
                    width: "20px"
                  }}
                />{" "}
                {getMessage(value)}
              </Label>
            </Col>
          );
          break;
        case "LOCATION":
          allModuleList.push(
            <Col className="paddingR0L3 pointerEventsNone" key={key} xs={12} lg={3}>
              <Label className="label noPadding">
                <img
                  src={this.props.sessionDetails.modules.includes(
                    modulesAvailableConstant.LOCATION) ? ic_checked_checkbox : ic_unchecked_checkbox}
                  className="customCheckbox"
                />
                <img
                  src={ic_location}
                  style={{
                    height: "20px",
                    width: "20px"
                  }}
                />{" "}
                {getMessage(value)}
              </Label>
            </Col>
          );
          break;
        case "PDF_EDITOR":
          allModuleList.push(
            <Col className="paddingR0L3 pointerEventsNone" key={key} xs={12} lg={3}>
              <Label className="label noPadding">
                <img
                  src={this.props.sessionDetails.modules.includes(
                    modulesAvailableConstant.PDF) ? ic_checked_checkbox : ic_unchecked_checkbox}
                  className="customCheckbox"
                />
                <img
                  src={ic_pdf}
                  style={{
                    height: "17px",
                    width: "17px"
                  }}
                />{" "}
                {getMessage(value)}
              </Label>
            </Col>
          );
          break;
        case "SNAP_SHOT":
          allModuleList.push(
            <Col className="paddingR0L3 pointerEventsNone" key={key} xs={12} lg={3}>
              <Label className="label noPadding">
                <img
                  src={this.props.sessionDetails.modules.includes(
                    modulesAvailableConstant.SNAPSHOT) ? ic_checked_checkbox : ic_unchecked_checkbox}
                  className="customCheckbox"
                />
                <img
                  src={ic_camera}
                  style={{
                    height: "20px",
                    width: "20px"
                  }}
                />{" "}
                {getMessage(value)}
              </Label>
            </Col>
          );
          break;
        case "APP_EMULATION":
          allModuleList.push(
            <Col className="paddingR0L3 pointerEventsNone" key={key} xs={12} lg={3}>
              <Label className="label noPadding">
                <img
                  src={this.props.sessionDetails.modules.includes(
                    modulesAvailableConstant.APP_EMULATION) ? ic_checked_checkbox : ic_unchecked_checkbox}
                  className="customCheckbox"
                />
                <img
                  src={ic_app_emulation}
                  style={{
                    height: "20px",
                    width: "20px"
                  }}
                />{" "}
                {getMessage(value)}
              </Label>
            </Col>
          );
          break;
        case "QR_CODE":
          allModuleList.push(
            <Col className="paddingR0L3 pointerEventsNone" key={key} xs={12} lg={3}>
              <Label className="label noPadding">
                <img
                  src={this.props.sessionDetails.modules.includes(
                    modulesAvailableConstant.QR_CODE) ? ic_checked_checkbox : ic_unchecked_checkbox}
                  className="customCheckbox"
                />
                <img
                  src={ic_QR_code}
                  style={{
                    height: "20px",
                    width: "20px"
                  }}
                />{" "}
                {getMessage(value)}
              </Label>
            </Col>
          );
          break;
        case "ALLOW_DOWNLOAD":
          allModuleList.push(
            <Col className="paddingR0L3 pointerEventsNone" key={key} xs={12} lg={3}>
              <Label className="label noPadding">
                <img
                  src={this.props.sessionDetails.modules.includes(
                    modulesAvailableConstant.ALLOW_DOWNLOAD) ? ic_checked_checkbox : ic_unchecked_checkbox}
                  className="customCheckbox"
                />
                <img
                  src={download_img}
                  style={{
                    height: "20px",
                    width: "20px"
                  }}
                />{" "}
                {getMessage(value)}
              </Label>
            </Col>
          );
          break;
        case "CO_BROWSE":
          allModuleList.push(
            <Col className="paddingR0L3 pointerEventsNone" key={key} xs={12} lg={3}>
              <Label className="label noPadding">
                <img
                  src={this.props.sessionDetails.modules.includes(
                    modulesAvailableConstant.CO_BROWSE) ? ic_checked_checkbox : ic_unchecked_checkbox}
                  className="customCheckbox"
                />
                <img
                  src={ic_admin_co_browse}
                  style={{
                    height: "20px",
                    width: "20px"
                  }}
                />{" "}
                {getMessage(value)}
              </Label>
            </Col>
          );
          break;
      }
    });
    return allModuleList;
  }

  indexN = (cell, row, enumObject, index) => {
    return (<div>{index + 1}</div>)
  }

  getSessionDataForObjectType = (objectType) => {
    return this.props.sessionObjects
      ? this.props.sessionObjects.filter(sessionObject => sessionObject.subLoggingLevel === objectType)
      : [];
  }

  render() {
    let canvasLinks = this.getSessionDataForObjectType(subLoggingLevels.advanced.CANVAS_OBJECTS);
    let pdfLinks = this.getSessionDataForObjectType(subLoggingLevels.advanced.PDF);
    const userName = getUserNameForSelectedLanguage(this.props.language, this.props.sessionDetails.owner);
    return (
      <div className="SessionDetailContainer mb-3">
        {this.PermissionModal()}
        {this.state.showPreview ?
          <>
            <Modal
              isOpen={this.state.showPreview}
              className="previewModal"
              backdrop="static">
              <ModalHeader className="previewModalHeader">
                <div>
                  <label className="mb-0 text-left previewModalHeaderText">{this.state.previewName}
                  </label>
                </div>
                <div className="closeButton">
                  <button type="button" className="close" aria-label="Close" 
                    onClick={() => this.setState({ showPreview: false })} >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
              </ModalHeader>
              <ModalBody className="previewBody">
                <Spinner showSpinner={this.state.spinnerVisible} />
                <Row className=''>
                  {this.state.previewType !== "PDF" ?
                    <div className="imgContainer">
                      <img src={this.state.previewLink} alt="preview" className="preImg" 
                        onLoad={() => this.setState({ showPreview: true, spinnerVisible: false })}
                      ></img>
                    </div>
                    :
                    <PdfViewer pdftronKey={this.props.pdftronKey} fileUrl={this.state.fileUrl} isReadOnlyPDF={true}
                      language={this.props.language}
                    />
                  }
                </Row>
              </ModalBody>
            </Modal>
          </>
          : null}
        <Row className="mainTitle flex5">
          <Col className="mainLabel pl-0">{getMessage("SESSION_DETAILS_TITLE")}</Col>
          <Col className="backBtn">
            <div className="cursorPointer" onClick={this.props.onBackClick}>
              {getMessage("BACK")}
            </div>
          </Col>
        </Row>
        <Row className="sessionDetailHeader">
          <Col xs={3} className="noPadding displayFlex">
            <label
              className="nameEllipsis m-0"
              title={this.props.sessionDetails.session_name}>
              {getMessage("SESSION_NAME")}: {this.props.sessionDetails.session_name}
            </label>
          </Col>
          <Col xs={3} className="noPadding displayFlex">
            <label
              className="nameEllipsis m-0"
              title={userName}>
              {getMessage("ROLE_AGENT")}: {userName}
            </label>
          </Col>
          <Col xs={3} className="noPadding">
            {getMessage("DATE")}: {formatDateByLocale(this.props.sessionDetails.start_time, this.props.language)} {getTimeInLocaleTimezone(this.props.sessionDetails.start_time)}
          </Col>
          <Col xs={3} className="noPadding">
            {getMessage("DURATION")}: {this.props.sessionDetails.duration ? `${this.props.sessionDetails.duration} ${getMessage("MINUTES")}` : "--"}
          </Col>
        </Row>
        <Row className="mainTitle flex5">
          {getMessage("INVITEES")}
        </Row>
        {this.props.inviteesList && this.props.inviteesList.length > 0 &&
          <BootstrapTable
            data={this.props.inviteesList.map((invitee) => {
              if (invitee && invitee.phone) {
                invitee.phone = getPhoneNumberWithoutCountryCode(invitee.phone);
              }
              return invitee;
            })}
            keyField="any"
            tableHeaderClass="tableHeader"
            tableBodyClass='tableBody'
            containerClass='organisationsList'
            tableContainerClass=''
            headerContainerClass=''
            bodyContainerClass=''
            bordered={false}
          >
            <TableHeaderColumn
              dataField="any"
              width="3%"
              dataFormat={this.indexN}
              dataAlign='center'
            >
              {getMessage("SR_NO")}
            </TableHeaderColumn>
            {/*<TableHeaderColumn
              dataField='name'
              width="15%"
              dataFormat={this.organizationFormat}
              dataAlign='center'
              isKey
            >
              {getMessage("NAME")}
            </TableHeaderColumn>*/}
            <TableHeaderColumn
              dataField='email'
              width="15%"
              dataFormat={this.organizationFormat}
              dataAlign='center'
            >
              {getMessage("EMAIL")}
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField='phone'
              width="15%"
              dataFormat={this.organizationFormat}
              dataAlign='center'
            >
              {getMessage("PHONE_NUMBER")}
            </TableHeaderColumn>
          </BootstrapTable>
        }
        <hr />
        <Row className="mainTitle flex5">
          {getMessage("FEATURE_USED")}
        </Row>
        <hr />
        <Row className="flex5 moduleList">
          {this.displayAllModuleList()}
        </Row>

        <hr />

        <Row className="mainTitle flex5">
          {getMessage("CANVAS_OBJECTS")}
        </Row>
        {<BootstrapTable
          data={canvasLinks}
          tableHeaderClass='tableHeader canvasHeader'
          tableBodyClass='tableBody canvasTableBody'
          bordered={false}
          options={getBootstrapTableOptions()}
          maxHeight='270px'
        >

          <TableHeaderColumn
            dataField="storageLink"
            width="50%"
            isKey
            dataFormat={this.displayLink}
          >
            {getMessage("FILE_NAME")}
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="id"
            width="40%"
            dataFormat={this.displayDownloadIcon}
            className="floatRight"
          >
            {getMessage("DOWNLOAD")}
          </TableHeaderColumn>
        </BootstrapTable>}

        <hr />
        <Row className="mainTitle flex5">
          {getMessage("PDF")}
        </Row>
        <hr />
        {<BootstrapTable
          data={pdfLinks}
          tableHeaderClass="tableHeader pdfTableHeader"
          tableBodyClass='tableBody pdfTableBody'
          bordered={false}
          options={getBootstrapTableOptions()}
          maxHeight='270px'
        >
          {/* <TableHeaderColumn
            dataField="select"
            width="10%"
            dataFormat={this.renderExportCheckboxes}
          >
            {getMessage("SELECT")}
          </TableHeaderColumn> */}
          <TableHeaderColumn
            dataField="storageLink"
            width="50%"
            dataFormat={this.displayLink}
          >
            {getMessage("FILE_NAME")}
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="id"
            width="40%"
            dataFormat={this.displayDownloadIcon}
            className="floatRight"
            isKey
          >
            {getMessage("DOWNLOAD")}
          </TableHeaderColumn>
        </BootstrapTable>}

        <hr />
        <Row className="mainTitle flex5">
          {getMessage("AUDIO_VIDEO_RECORDING")}
        </Row>
        <hr />
        {<BootstrapTable
          data={this.props.recordingObjects}
          tableHeaderClass="tableHeader recordingHeader"
          tableBodyClass='tableBody recordingBody'
          bordered={false}
          options={getBootstrapTableOptions()}
          maxHeight='270px'
          className="mb-5"
        >
          <TableHeaderColumn
            dataField="storageLink"
            width="50%"
            dataFormat={this.displayRecordingLink}
          >
            {getMessage("FILE_NAME")}
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="fileSize"
            width="20%"
            dataFormat={this.displayFileSize}
          >

            {getMessage("FILE_SIZE")}
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="id"
            width="20%"
            dataFormat={(cell, row) => this.displayRecordingDownloadIcon(cell, row)}
            className="floatRight"
            isKey
          >
            {getMessage("DOWNLOAD")}
          </TableHeaderColumn>
        </BootstrapTable>}

        {/* {(canvasLinks.length > 0 || pdfLinks.length > 0) ?
          <div>
            <hr />
            <div className="text-center mt-4 mb-5">
              <Button className="exportBtn buttons">
                {getMessage("EXPORT")}
              </Button>
            </div>
          </div>
          : ""} */}
      </div>
    )
  }
}
